import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useRedeemImpersonation } from '../../context/auth.context'
import { useLoad } from '../../shared/hooks/load'
import { AlertError } from '../../shared/alert/alert-error'

const NO_LONGER_VALID = 'This impersonation link is no longer valid. Start the impersonation again from the admin panel.'

// The one-time code from the fragment: "#<code>" (or "#code=<code>").
export const codeFromHash = hash => {
  const value = (hash || '').replace(/^#/, '')
  const code = value.startsWith('code=') ? value.slice('code='.length) : value
  return code || null
}

// The impersonated session's new tab. The admin's POST /auth-impersonate
// answered a 60-second, single-use code, which arrives in the fragment; it
// is dropped from the address bar and history before anything else, then
// redeemed once for the session's tokens (POST /auth-impersonate/redeem).
export const RedirectImpersonate = () => {
  const history = useHistory()
  const redeemImpersonation = useRedeemImpersonation()

  const [code] = useState(() => {
    const found = codeFromHash(window.location.hash)
    if (found) window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search)
    return found
  })
  const [error, updateError] = useState()
  const [refused, setRefused] = useState(false)

  useLoad(async () => {
    if (!code) return
    try {
      await redeemImpersonation(code)
      history.replace('/')
    } catch (e) {
      // A spent, expired or unknown code: say so (not the sign-in notice).
      if (e && e.status === 401) setRefused(true)
      else updateError(e)
    }
  }, [code])

  if (!code || refused) return <NoLongerValid />

  return (
    <React.Fragment>
      <AlertError error={error} />
      {!error && <div role="status">Opening the impersonated session…</div>}
    </React.Fragment>
  )
}

// The retired /redirect/impersonate/<refreshToken> URL: a refresh token in a
// URL is never accepted again, so it opens nothing.
export const RedirectImpersonateRetired = () => <NoLongerValid />

const NoLongerValid = () => <div className="alert alert-warning" role="alert">{NO_LONGER_VALID}</div>
